import React from 'react';
import { motion } from 'framer-motion';
import { copy } from '../../data/copy';
import BaseBadge from './BaseBadge';

const ContactBadge = () => (
  <BaseBadge colorFrom="#22d3ee" colorTo="#3b82f6" title="Contact">
    {/* Content Container (Pushes bottom elements down) */}
    <div className="flex flex-col flex-grow items-center justify-between text-center">
      
      {/* Top Text */}
      <div className="w-full mb-8">
        <h3 className="text-3xl font-light text-white mb-4">
          Have a <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 tracking-wide">Vision?</span>
        </h3>
        <p className="text-[15px] text-white/70 leading-relaxed max-w-[280px] mx-auto">
          Whether it's launching a new landing page or orchestrating a complex data integration, let's build something extraordinary together.
        </p>
      </div>

      {/* Primary CTA Button */}
      <motion.a
        href={`mailto:${copy.contact.email}?subject=New Project Inquiry`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-full max-w-[280px] mb-8 inline-flex items-center justify-center gap-3 px-6 py-4 rounded-xl bg-white/[0.08] border border-white/15 font-semibold font-header text-white"
        whileHover={{ 
          scale: 1.03, 
          backgroundColor: "rgba(255,255,255,0.12)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)" 
        }}
        whileTap={{ scale: 0.98 }}
        transition={{ type: "spring", stiffness: 400, damping: 20 }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
          <rect x="2" y="4" width="20" height="16" rx="2" />
        </svg>
        <span>Send an Email</span>
      </motion.a>

      {/* Direct link & Social stack at bottom */}
      <div className="w-full space-y-4">
        <p className="text-sm text-white/50">
          Or email directly:{" "}
          <a
            href={`mailto:${copy.contact.email}`}
            className="text-white/80 hover:text-white hover:underline transition-colors block mt-1"
          >
            {copy.contact.email}
          </a>
        </p>

        {/* GitHub Icon */}
        <div className="flex justify-center pt-2">
          <motion.a
            href="https://github.com/Pilgy"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-xl bg-white/[0.05] border border-white/10 flex items-center justify-center text-white/70 hover:text-white"
            whileHover={{ scale: 1.1, backgroundColor: "rgba(255,255,255,0.1)" }}
            whileTap={{ scale: 0.95 }}
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
            </svg>
          </motion.a>
        </div>
      </div>
    </div>
  </BaseBadge>
);

export default ContactBadge;
